import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05569bda")

_pushScopeId("data-v-05569bda")
const _hoisted_1 = { class: "MemberWork" }
const _hoisted_2 = { class: "MemberWork__date-filter" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Table = _resolveComponent("Table")
  const _component_AdaptiveWindowLayout = _resolveComponent("AdaptiveWindowLayout")

  return (_openBlock(), _createBlock(_component_AdaptiveWindowLayout, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DateRangePicker, {
          startDate: _ctx.startDate,
          "onUpdate:startDate": _cache[1] || (_cache[1] = $event => (_ctx.startDate = $event)),
          endDate: _ctx.endDate,
          "onUpdate:endDate": _cache[2] || (_cache[2] = $event => (_ctx.endDate = $event)),
          afterDateChanged: () => _ctx.changeDate({ startDate: _ctx.startDate, endDate: _ctx.endDate }, _ctx.ChangeDateType.DATE_RANGE),
          badges: [_ctx.nowDate]
        }, null, 8, ["startDate", "endDate", "afterDateChanged", "badges"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.dateRange,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.dateRange = $event)),
            size: _ctx.CheckboxSizeType.H42,
            type: _ctx.CheckboxType.SINGLE,
            items: _ctx.dateFilterItems,
            checkedItemId: _ctx.checkedDateRangeId,
            afterOnInput: () => _ctx.changeDate({ startDate: _ctx.dateRange, endDate: _ctx.nowDate }, _ctx.ChangeDateType.CHECKBOX),
            name: "dateRange"
          }, null, 8, ["modelValue", "size", "type", "items", "checkedItemId", "afterOnInput"])
        ]),
        (_ctx.isLoaded)
          ? (_openBlock(), _createBlock(_component_Table, {
              key: 0,
              headers: _ctx.tableHeader,
              data: _ctx.tableContent,
              click: [{ key: 'userName', onClick: (row) => _ctx.goMemberWork(row) }]
            }, null, 8, ["headers", "data", "click"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
})